import { createApi } from '@reduxjs/toolkit/query/react'
import { ENDPOINTS } from '@constants/index'
import { dbBaseQueryWithReauth } from './baseQuery'
import { AttachmentRequest, AttachmentUrl } from '@typesApp/Attachment'

export const attachmentsApi = createApi({
  reducerPath: 'attachmentsApi',
  baseQuery: dbBaseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: builder => ({
    getAttachmentUrl: builder.mutation<AttachmentUrl, AttachmentRequest>({
      query: ({ attachmentType, attachmentId }) => ({
        url: `${ENDPOINTS.DIRECT_BILLING.ATTACHMENTS}/${attachmentId}/get-url`,
        method: 'POST',
        body: {
          attachmentId,
          attachmentType,
        },
      }),
    }),
    getInsuranceFormAttachmentUrl: builder.mutation<AttachmentUrl, AttachmentRequest>({
      query: ({ attachmentId }) => ({
        url: `${ENDPOINTS.DIRECT_BILLING.ATTACHMENTS}/${attachmentId}/get-insurance-form-url`,
        method: 'POST',
      }),
    }),
    getAttachmentBlobUrl: builder.query<string, { url: string; mimeType?: string }>({
      query: ({ url, mimeType }) => ({
        url: url,
        responseHandler: response =>
          response.blob().then(blob => URL.createObjectURL(mimeType ? new Blob([blob], { type: mimeType }) : blob)),
      }),
    }),
  }),
})

export const {
  useGetAttachmentUrlMutation,
  useGetInsuranceFormAttachmentUrlMutation,
  useLazyGetAttachmentBlobUrlQuery,
} = attachmentsApi
